import { defineMessages } from 'react-intl';

export const i18n: {
	sharePromptTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closeButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	informationLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	useCaseLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	roleLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connectedAppsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	fromOwner: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	privacyNote: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	privacyNoteNoOrganization: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copyLinkButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	linkCopied: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorShareFailed: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	sharePromptTitle: {
		id: 'rovo-conversation-actions.share-prompt-modal.title',
		defaultMessage: 'Share prompt',
		description: 'Title for the share prompt modal',
	},
	closeButtonLabel: {
		id: 'rovo-conversation-actions.share-prompt-modal.close-button-label',
		defaultMessage: 'Close',
		description: 'Aria label for the close button',
	},
	informationLabel: {
		id: 'rovo-conversation-actions.share-prompt-modal.information-label',
		defaultMessage: 'Information',
		description: 'Header for the information section showing metadata',
	},
	useCaseLabel: {
		id: 'rovo-conversation-actions.share-prompt-modal.use-case-label',
		defaultMessage: 'Use case',
		description:
			'Label shown for the use case field in the information section of the share prompt modal',
	},
	roleLabel: {
		id: 'rovo-conversation-actions.share-prompt-modal.role-label',
		defaultMessage: 'Role',
		description:
			'Label shown for the role field in the information section of the share prompt modal',
	},
	connectedAppsLabel: {
		id: 'rovo-conversation-actions.share-prompt-modal.connected-apps-label',
		defaultMessage: 'Connected apps',
		description: 'Label for the connected apps field',
	},
	fromOwner: {
		id: 'rovo-conversation-actions.share-prompt-modal.from-owner',
		defaultMessage: 'From {name}',
		description: 'Shows who created/owns the prompt',
	},
	privacyNote: {
		id: 'rovo-conversation-actions.share-prompt-modal.privacy-note',
		defaultMessage: 'Shared only within {organizationName}',
		description:
			'Privacy note about sharing scope. organizationName is the name of the users organization (e.g. Atlassian, Google, SAP)',
	},
	privacyNoteNoOrganization: {
		id: 'rovo-conversation-actions.share-prompt-modal.privacy-note-no-organization',
		defaultMessage: 'Shared only within your organization',
		description:
			'Privacy note about sharing scope when the user organization name is not available',
	},
	copyLinkButton: {
		id: 'rovo-conversation-actions.share-prompt-modal.copy-link-button',
		defaultMessage: 'Copy link',
		description: 'Button text for copying the share link',
	},
	linkCopied: {
		id: 'rovo-conversation-actions.share-prompt-modal.link-copied',
		defaultMessage: 'Link copied!',
		description: 'Success message shown after link is copied',
	},
	errorShareFailed: {
		id: 'rovo-conversation-actions.share-prompt-modal.error-share-failed',
		defaultMessage: 'Failed to share prompt. Please try again.',
		description: 'Error message shown when the prompt sharing fails',
	},
});
